<template>
    <div 
      class="px-5 mt-8">
      <v-dialog v-model="dialog.success"
        width="350">
        <v-card 
          class="border-radius pa-2">
          <v-card-text>
            <v-img 
              width="125"
              height="125"
              alt="kominfoklaten" 
              :src="require('@/assets/icon/info_berhasil.png')"
              class="ma-auto my-6">
              <template v-slot:placeholder>
                <v-row
                  class=" "
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
  
            <div
              class="body-1 text-center line-text-second">
              <div>
                Terima kasih, Pengiriman
              </div>
  
              <div>
                telah berhasil dikonfirmasi!
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog.status"
        @keydown.esc="dialog.status = false"
        :fullscreen="dialog.fullscreen"
        width="500"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
          class="pa-8 pt-6">
          <v-card-title 
            class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
            
            Mengubah Status
  
            <v-spacer/>
  
            <v-icon 
              @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
              class="cursor-pointer"
              size="18"
              color="#000000">
              mdi-close
            </v-icon>
          </v-card-title>
          
          <v-card-text 
            class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
            Apakah Anda yakin mengkonfirmasi pengiriman surat jalan ini?
  
  
            <div v-if="message.error.length > 0"
              class="text-left mt-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
  
  
          <v-card-actions
            class="pa-0 pt-4">
            <v-spacer/>
  
            <v-btn
              rounded
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              width="190"
              height="45"
              elevation="0"
              color="#1814F3"
              class="fs-16 white--text text-capitalize border-radius">
              Ya, {{ message.status }}
            </v-btn>
  
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="dialog.bukti"
        @keydown.esc="dialog.bukti = false"
        v-if="dialog.bukti"
        :fullscreen="dialog.fullscreen"
        width="600"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
          class="">
          <v-card-title 
            class="d-flex align-center pb-4 text-right popup-header fs-18 font-weight-bold">
            
            Bukti Pengiriman
  
            <v-spacer/>
  
            <v-icon 
              @click="dialog.bukti = false; dialog.fullscreen = false;"
              class="cursor-pointer"
              size="18"
              color="#000000">
              mdi-close
            </v-icon>
          </v-card-title>
          
          <v-divider 
            class="mb-2"
            style="border-top: 2px dashed #e0e0e0;"/>
  
          <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0" v-if="selected.detail.length > 0">
            <table style="width: auto;">
              <tr>
                <td class="fs-13 py-1">
                  No BPB
                </td>
                <td style="width: 40px" class="fs-13 text-center">
                  : 
                </td>
                <td class="fs-13 text-left">
                  {{ selected.detail[0].bpb_number }}
                </td>
              </tr>
              <tr>
                <td class="fs-13 py-1">
                  Nama Toko
                </td>
                <td style="width: 40px" class="fs-13 text-center">
                  : 
                </td>
                <td class="fs-13 text-left">
                  {{ selected.detail[0].store_name }}
                </td>
              </tr>
              <tr>
                <td class="fs-13 py-1">
                  No. Order
                </td>
                <td style="width: 40px" class="fs-13 text-center">
                  : 
                </td>
                <td class="fs-13 text-left">
                  {{ selected.detail[0].orders_number }}
                </td>
              </tr>
            </table>
  
            <div class="mt-2" v-for="(item, index) in selected.detail[0].foto_bukti_json" :key="index">
              <img 
                :src="item"
                alt="Mitra Warung" 
                style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
            </div>
  
            <v-card-text
              v-if="selected.detail[0].foto_bukti_json.length === 0"
              class="pb-0 my-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <v-img 
                  class="mx-auto"
                  contain
                  alt="vuetify"
                  :width="90"
                  :height="90"
                  :src="require('@/assets/image/empty.png')">
                  <!-- <template v-slot:placeholder>
                    <v-row
                      class=" "
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template> -->
                </v-img>
                <div class="mt-3 fs-16">
                  Belum Ada Data Foto
                </div>
              </div>
            </v-card-text>
  
          </v-card-text>
  
  
          <v-card-actions
            class="">
            <v-spacer/>
  
            <v-btn
              rounded
              width="120"
              @click="dialog.bukti = false; dialog.fullscreen = false;"
              outlined
              class="body-2 font-weight-bold text-capitalize red--text">
              Tutup
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>


      <v-layout wrap>
        <v-flex>
          <section>
            <v-card flat class="mb-0">
              <div class="px-6 py-4">
                <div class="d-flex align-center justify-space-between w-100">
                  <div>
                    <h1 class="fs-16 font_weight_600 mb-1">
                      Reschedule BPB
                    </h1>
                    <p class="fs-13 text--secondary mb-0">
                      Detail surat jalan <span class="font_weight_600 black--text">{{ detail.number }}</span>
                    </p>
                    <p class="fs-12 text--secondary mb-0 mt-1">
                      <v-icon size="14" class="mr-1">mdi-calendar-clock</v-icon>
                      Tanggal pengiriman: {{ detail.date | date }}
                    </p>
                    <p class="fs-12 text--secondary mb-0 mt-1">
                      <v-icon size="14" class="mr-1">mdi-truck-delivery</v-icon>
                      Driver: {{ detail.driver_name }} | Kendaraan: {{ detail.vehicle_name }}
                    </p>
                  </div>
                  <div class="d-flex align-center">
                    <v-btn
                      color="primary"
                      elevation="0"
                      small
                      @click="fetchDetail()"
                      :loading="process.load"
                      class="text-capitalize"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Refresh
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
  
            <v-row
              class="mt-0">
              <v-col 
                cols="12"
                class="py-0">
  
                <v-row>
                  <v-col cols="12" md="4" class="pr-0">
                    <v-card 
                      flat
                      style="border-radius: 8px; min-height: 100%;">
                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-2 title">
                            Mohon Tunggu...
                          </div>
                          <v-progress-circular
                            indeterminate
                          ></v-progress-circular>
                        </div>
                      </v-card-text>
  
                      <v-card-text v-if="!process.load && Object.keys(detail).length > 0" class="pt-0">
                        <div class="fs-14 input-label font_weight_600 pt-2 pb-5 black--text">
                          Data BPB
                        </div>

                        <div class="black--text">
                          <div v-for="(item, index) in bpb_list_old" :key="index">
                            <div class="fs-13 font_weight_600 mb-4" style="border: 1px solid #e0e0e0; padding: 10px; border-radius: 4px;">
                              <div class="d-flex justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">No BPB:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.bpb_number }}</div>
                              </div>
                              <div class="d-flex justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">Nama Toko:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.store_name }}</div>
                              </div>
                              <div class="d-flex justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">Nama Sales:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.sales_name }}</div>
                              </div>
                              <div class="d-flex justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">Wilayah:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.wilayah }}</div>
                              </div>
                              <div class="d-flex justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">No. Order:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.orders_number }}</div>
                              </div>
                              <div class="justify-space-between mb-1">
                                <div class="fs-12" style="font-weight: 300;">Alamat:</div>
                                <div class="fs-12" style="font-weight: 700;">{{ item.shipping_province }}, {{ item.shipping_city }}</div>
                              </div>

                              <v-divider class="my-2"></v-divider>

                              <div class="fs-12 font_weight_600 mb-2">Detail Varian:</div>
                              <div v-for="(detail, index) in item.detail" :key="index" class="mb-2 pa-2" style="background: #f5f5f5; border-radius: 4px;">
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="fs-12" style="font-weight: 300;">Varian:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.varian_name }}</span>
                                </div>
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="fs-12" style="font-weight: 300;">SKU:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.varian_sku }}</span>
                                </div>
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="fs-12" style="font-weight: 300;">Qty Dikirim:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.qty_dus | number }} {{ detail.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</span>
                                </div>
                                <div class="d-flex justify-space-between mb-1"> 
                                  <span class="fs-12" style="font-weight: 300;">Qty Diterima:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.qty_dus_diterima | number }} {{ detail.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</span>
                                </div>
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="fs-12" style="font-weight: 300;">Qty Dikembalikan:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.qty_dus_return | number }} {{ detail.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</span>
                                </div>
                                <div class="d-flex justify-space-between mb-1">
                                  <span class="fs-12" style="font-weight: 300;">Qty Rusak:</span>
                                  <span class="fs-12 font-weight-bold">{{ detail.kirim_qty_dus_rusak | number }} {{ detail.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
  
                  <v-col cols="12" md="8" class="">
                    <v-card 
                      flat
                      style="border-radius: 8px; min-height: 100%;">
                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-2 title">
                            Mohon Tunggu...
                          </div>
                          <v-progress-circular
                            indeterminate
                          ></v-progress-circular>
                        </div>
                      </v-card-text>
  
                      <v-card-text v-if="!process.load && Object.keys(detail).length > 0" class="pt-0">
                        <div class="fs-14 input-label font_weight_600 pt-2 pb-1 black--text">
                          Form Reschedule BPB
                        </div>
                        
                        <!-- <v-alert
                          v-if="data_bpb.length > 0"
                          type="info"
                          class="mb-4"
                          dense
                          outlined>
                          <div class="d-flex align-center">
                            <v-icon left>mdi-information</v-icon>
                            <span class="fs-13">
                              Total {{ data_bpb.length }} BPB tersedia untuk direschedule. Pilih BPB lama dan BPB baru untuk melakukan reschedule.
                            </span>
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Total Varian:</strong> {{ getTotalVariants() }} varian tersedia untuk direschedule
                            <v-chip small color="info" text-color="white" class="fs-10 ml-1">
                              Multi-Varian Support
                            </v-chip>
                            <v-chip small color="success" text-color="white" class="fs-10 ml-1">
                              Advanced
                            </v-chip>
                            <v-chip small color="primary" text-color="white" class="fs-10 ml-1">
                              Comprehensive
                            </v-chip>
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Catatan:</strong> Reschedule akan mengganti BPB lama dengan BPB baru dalam surat jalan ini. Pastikan BPB baru sudah siap untuk dikirim dan semua varian tersedia.
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Proses:</strong> 1. Pilih BPB lama → 2. Pilih BPB baru → 3. Review detail varian → 4. Simpan reschedule
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Status:</strong> 
                            <v-chip small color="orange" text-color="white" class="fs-10 ml-1">Draft</v-chip>
                            <span class="ml-1">Siap untuk direschedule ({{ getTotalVariants() }} varian)</span>
                            <v-chip small color="success" text-color="white" class="fs-10 ml-1">
                              Ready
                            </v-chip>
                            <v-chip small color="info" text-color="white" class="fs-10 ml-1">
                              Optimized
                            </v-chip>
                            <v-chip small color="warning" text-color="white" class="fs-10 ml-1">
                              Verified
                            </v-chip>
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Peringatan:</strong> Reschedule akan mengubah data pengiriman untuk semua varian. Pastikan semua pihak terkait telah diberitahu.
                          </div>
                          <div class="fs-12 mt-1">
                            <strong>Timeline:</strong> Proses ini akan segera mempengaruhi jadwal pengiriman dan laporan terkait untuk semua varian yang direschedule.
                          </div>
                        </v-alert> -->
                        
                        <div v-if="process.load" class="text-center py-8">
                          <v-progress-circular
                            indeterminate
                            size="50"
                            :color="set_color"
                          ></v-progress-circular>
                          <div class="mt-3 fs-14">Memuat data...</div>
                        </div>
                        
                        <ValidationObserver ref="form_reschedule">
                          <v-form v-if="!process.load">
                            <v-row>
                              <v-col cols="12" md="6" class="pb-0">
                                <ValidationProvider name="Pilih BPB yang akan direschedule" rules="required" v-slot="{ errors }">
                                  <div class="fs-13 label-input mb-1">
                                    <span class="red--text">*</span>
                                    Pilih BPB Lama
                                  </div>
                                  <v-autocomplete
                                    v-on:keydown.enter.prevent="saveReschedule()"
                                    :items="bpb_list_old"
                                    item-value="bpb_id"
                                    item-text="bpb_number"
                                    :item-color="set_color"
                                    filled
                                    rounded
                                    dense
                                    v-model="form_reschedule.bpb_id"
                                    class="custom-placeholder-autocomplete"
                                    solo
                                    color="#718EBF"
                                    placeholder="Pilih BPB yang akan direschedule"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    @change="onBpbSelected"
                                  />
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="pb-0">
                                <ValidationProvider name="No BPB Baru" rules="required" v-slot="{ errors }">
                                  <div class="fs-13 label-input mb-1">
                                    <span class="red--text">*</span>
                                    Pilih BPB Baru
                                  </div>
                                  <v-autocomplete
                                    v-on:keydown.enter.prevent="saveReschedule()"
                                    :items="bpb_list"
                                    item-value="id"
                                    item-text="number"
                                    :item-color="set_color"
                                    filled
                                    rounded
                                    dense
                                    class="custom-placeholder-autocomplete"
                                    solo
                                    color="#718EBF"
                                    placeholder="Pilih No BPB Baru"
                                    v-model="form_reschedule.new_bpb_id"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    @change="onNewBpbSelected"
                                  />
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row v-if="form_reschedule.bpb_id && form_reschedule.new_bpb_id">
                              <v-col cols="12">
                                <v-card outlined class="pa-4">
                                  <div class="fs-14 font_weight_600 mb-3">
                                    Detail Perbandingan BPB
                                  </div>
                                  <v-alert
                                    type="info"
                                    class="mb-3"
                                    dense
                                    outlined>
                                    <div class="fs-12">
                                      <strong>Informasi:</strong> Berikut adalah perbandingan detail antara BPB lama dan BPB baru yang akan direschedule. varian BPB lama sama dengan Varian BPB Baru
                                    </div>
                                    <div class="fs-12 mt-1">
                                      <strong>Validasi:</strong> Pastian Selisih Quantity (Berdasarkan Varian) tidak ada yang negatif
                                    </div>
                                  </v-alert>
                                
                                  <v-row>
                                    <v-col cols="12" md="6">
                                      <div class="fs-13 font_weight_600 mb-2">BPB Lama</div>
                                      <div v-if="selected_bpb_detail">
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">No BPB:</div>
                                          <div class="fs-11 text-right" style="font-weight: 700;">{{ selected_bpb_detail.bpb_number }}</div>
                                        </div>
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">Nama Toko:</div>
                                          <div class="fs-11 text-right" style="font-weight: 700;">{{ selected_bpb_detail.store_name }}</div>
                                        </div>
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">Nama Sales:</div>
                                          <div class="fs-11 text-right" style="font-weight: 700;">{{ selected_bpb_detail.sales_name }}</div>
                                        </div>
                                        <div class="justify-space-between mb-1">
                                          <div class="fs-11">Alamat:</div>
                                          <div class="fs-11" style="font-weight: 700; min-height: 44px;">{{ selected_bpb_detail.shipping_province }}, {{ selected_bpb_detail.shipping_city }}</div>
                                        </div>
                                        <!-- <div class="d-flex justify-space-between mb-1">
                                          <span class="fs-13">Status:</span>
                                          <v-chip
                                            small
                                            :color="selected_bpb_detail.is_store_closed === '1' ? 'red' : 'green'"
                                            text-color="white"
                                            class="fs-11">
                                            {{ selected_bpb_detail.is_store_closed === '1' ? 'Toko Tutup' : 'Toko Buka' }}
                                          </v-chip>
                                        </div> -->
                                        
                                        <v-divider class="my-2"></v-divider>
                                        
                                        <div class="fs-12 font_weight_600 mb-2">Detail Varian:</div>
                                        <div v-for="(detail, index) in selected_bpb_detail.detail" :key="index" class="mb-2 pa-2" style="background: #f5f5f5; border-radius: 4px;">
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-12">Varian:</span>
                                            <span class="fs-12 font-weight-bold">{{ detail.varian_name }}</span>
                                          </div>
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-12">SKU:</span>
                                            <span class="fs-12 font-weight-bold">{{ detail.varian_sku }}</span>
                                          </div>
                                          <!-- <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-12">Qty Pcs:</span>
                                            <span class="fs-12 font-weight-bold">{{ detail.qty_pcs }}</span>
                                          </div> -->
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-12">Qty:</span>
                                            <span class="fs-12 font-weight-bold">{{ detail.qty_dus | number }} {{ detail.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</span>
                                          </div>
                                          <!-- <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-12">Qty Lusin:</span>
                                            <span class="fs-12 font-weight-bold">{{ detail.qty_lusin }}</span>
                                          </div> -->
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                      <div class="fs-13 font_weight_600 mb-2">BPB Baru</div>
                                      <div v-if="selected_new_bpb_detail">
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">No BPB:</div>
                                          <div class="fs-12 text-right" style="font-weight: 700;">{{ selected_new_bpb_detail.number }}</div>
                                        </div>
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">Nama Toko:</div>
                                          <div class="fs-12 text-right" style="font-weight: 700;">{{ selected_new_bpb_detail.store_name }}</div>
                                        </div>
                                        <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-11">Nama Sales:</div>
                                          <div class="fs-12 text-right" style="font-weight: 700;">{{ selected_new_bpb_detail.sales_name }}</div>
                                        </div>
                                        <div class="justify-space-between mb-1">
                                          <div class="fs-11">Alamat:</div>
                                          <div class="fs-11" style="font-weight: 700; min-height: 44px;">{{ selected_new_bpb_detail.customer_shipping_province }}, {{ selected_new_bpb_detail.customer_shipping_city }}</div>
                                        </div>
                                        <!-- <div class="d-flex justify-space-between mb-1">
                                          <div class="fs-13">Status:</div>
                                          <v-chip
                                            small
                                            color="blue"
                                            text-color="white"
                                            class="fs-11">
                                            BPB Baru
                                          </v-chip>
                                        </div> -->
                                        
                                        <v-divider class="my-2"></v-divider>
                                        
                                        <div class="fs-12 font_weight_600 mb-2">Detail Varian:</div>
                                        <div v-for="(detail, index) in selected_new_bpb_detail.bpb_detail" :key="index" class="mb-2 pa-2" style="background: #f0f8ff; border-radius: 4px;">
                                          <div class="d-flex justify-space-between mb-1">
                                            <div class="fs-12">Varian:</div>
                                            <div class="fs-12 font-weight-bold">{{ detail.bpb_detail_varian_name }}</div>
                                          </div>
                                          <div class="d-flex justify-space-between mb-1">
                                            <div class="fs-12">SKU:</div>
                                            <div class="fs-12 font-weight-bold">{{ detail.bpb_detail_varian_sku }}</div>
                                          </div>
                                          <!-- <div class="d-flex justify-space-between mb-1">
                                            <div class="fs-12">Qty Pcs:</div>
                                            <div class="fs-12 font-weight-bold">{{ detail.bpb_detail_qty_pcs }}</div>
                                          </div> -->
                                          <div class="d-flex justify-space-between mb-1">
                                            <div class="fs-12">Qty:</div>
                                            <div class="fs-12 font-weight-bold">{{ detail.bpb_detail_qty_dus | number }} {{ selected_new_bpb_detail.detail[index].orders_detail_total_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}</div>
                                          </div>
                                          <!-- <div class="d-flex justify-space-between mb-1">
                                            <div class="fs-12">Qty Lusin:</div>
                                            <div class="fs-12 font-weight-bold">{{ detail.bpb_detail_qty_lusin }}</div>
                                          </div> -->
                                        </div>
                                      </div>
                                    </v-col>
                                  </v-row>

                                  <v-divider class="my-3"></v-divider>

                                  <v-row>
                                    <v-col cols="12">
                                      <div class="fs-13 font_weight_600 mb-2">
                                        Selisih Quantity (Berdasarkan Varian)
                                      </div>
                                      <v-alert
                                        v-if="Object.keys(selisihByVarian).length > 0"
                                        :type="getAlertStatus().type"
                                        class="mb-3"
                                        dense
                                        outlined>
                                        <div class="fs-12">
                                          <strong>Ringkasan:</strong> 
                                          {{ getAlertStatus().message }}
                                        </div>
                                      </v-alert>
                                      
                                      <!-- Selisih per varian -->
                                       <div v-if="getAlertStatus().type !== 'error'">
                                         <div v-for="(varian, varianId) in selisihByVarian" :key="varianId" class="mb-3 pa-3" style="border: 1px solid #e0e0e0; border-radius: 8px;">
                                           <div class="fs-13 font-weight-bold mb-2">
                                             <v-icon left color="#1814F3" size="14">mdi-package-variant</v-icon>
                                             {{ varian.varian_name }} ({{ varian.varian_sku }})
   
                                           <v-chip 
                                               small 
                                               :color="(varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) === 0 ? 'error' : (varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) < (varian.qty_pcs_new + varian.qty_dus_new + varian.qty_lusin_new) ? 'warning' : 'success'" 
                                               text-color="white" 
                                               class="fs-10">
                                               {{ (varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) === 0 ? 'Quantity Tidak Ada' : (varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) < (varian.qty_pcs_new + varian.qty_dus_new + varian.qty_lusin_new) ? 'Quantity Kurang' : 'Quantity Cukup' }}
                                               <v-icon right size="12" class="ml-1">
                                                 {{ (varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) === 0 ? 'mdi-alert' : (varian.qty_pcs_old + varian.qty_dus_old + varian.qty_lusin_old) < (varian.qty_pcs_new + varian.qty_dus_new + varian.qty_lusin_new) ? 'mdi-alert' : 'mdi-check' }}
                                               </v-icon>
                                             </v-chip>
                                           </div>
                                           <v-row>
                                             <!-- <v-col cols="12" md="4">
                                               <div class="d-flex justify-space-between mb-1">
                                                 <span class="fs-12">Pcs:</span>
                                                 <div class="d-flex align-center">
                                                   <span class="fs-12 font-weight-bold" :class="varian.selisih_pcs < 0 ? 'red--text' : varian.selisih_pcs > 0 ? 'green--text' : 'grey--text'">
                                                     {{ varian.qty_pcs_old }} → {{ varian.qty_pcs_new }}
                                                     <span class="ml-1">({{ varian.selisih_pcs > 0 ? '' : '' }}{{ varian.selisih_pcs }})</span>
                                                   </span>
                                                   <v-icon v-if="varian.selisih_pcs < 0" size="14" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                                   <v-icon v-else-if="varian.selisih_pcs > 0" size="14" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                                   <v-icon v-else size="14" color="grey" class="ml-1">mdi-minus</v-icon>
                                                 </div>
                                               </div>
                                             </v-col> -->
                                             <v-col cols="12" md="12">
                                               <div>
                                                 <!-- <span class="fs-13">{{ varian.total_in_dus*1 > 1 ? 'Dus' : 'Pcs' }}:</span> -->
                                                 <!-- <div class="d-flex align-center">
                                                   <span class="fs-13 font-weight-bold" :class="varian.selisih_dus < 0 ? 'red--text' : varian.selisih_dus > 0 ? 'green--text' : 'grey--text'">
                                                     {{ varian.qty_dus_old }} → {{ varian.qty_dus_new }}
                                                     <span class="ml-1">({{ varian.selisih_dus > 0 ? '' : '' }}{{ varian.selisih_dus }})</span>
                                                   </span>
                                                   <v-icon v-if="varian.selisih_dus < 0" size="14" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                                   <v-icon v-else-if="varian.selisih_dus > 0" size="14" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                                   <v-icon v-else size="14" color="grey" class="ml-1">mdi-minus</v-icon>
                                                 </div> -->
   
                                                 <div class="d-flex justify-space-between mb-1">
                                                 <span class="fs-12">Quantity Lama:</span>
                                                 <span class="fs-12" style="font-weight: 700;" :class="varian.selisih_dus < 0 ? 'red--text' : varian.selisih_dus > 0 ? 'green--text' : 'grey--text'">{{ varian.qty_dus_old }}</span>
                                               </div>
                                               <div class="d-flex justify-space-between mb-1">
                                                 <span class="fs-12">Quantity Baru:</span>
                                                 <span class="fs-12" style="font-weight: 700;" :class="varian.selisih_dus < 0 ? 'red--text' : varian.selisih_dus > 0 ? 'green--text' : 'grey--text'">{{ varian.qty_dus_new }}</span>
                                               </div>
   
                                               <v-divider></v-divider>
                                               <div class="d-flex justify-space-between mb-1">
                                                 <span class="fs-12">Selisih</span>
                                                 <span class="fs-12" style="font-weight: 700;" :class="varian.selisih_dus < 0 ? 'red--text' : varian.selisih_dus > 0 ? 'green--text' : 'grey--text'">{{ varian.selisih_dus }}</span>
                                               </div>
                                               </div>
                                             </v-col>
                                             <!-- <v-col cols="12" md="4">
                                               <div class="d-flex justify-space-between mb-1">
                                                 <span class="fs-12">Lusin:</span>
                                                 <div class="d-flex align-center">
                                                   <span class="fs-12 font-weight-bold" :class="varian.selisih_lusin < 0 ? 'red--text' : varian.selisih_lusin > 0 ? 'green--text' : 'grey--text'">
                                                     {{ varian.qty_lusin_old }} → {{ varian.qty_lusin_new }}
                                                     <span class="ml-1">({{ varian.selisih_lusin > 0 ? '' : '' }}{{ varian.selisih_lusin }})</span>
                                                   </span>
                                                   <v-icon v-if="varian.selisih_lusin < 0" size="14" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                                   <v-icon v-else-if="varian.selisih_lusin > 0" size="14" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                                   <v-icon v-else size="14" color="grey" class="ml-1">mdi-minus</v-icon>
                                                 </div>
                                               </div>
                                             </v-col> -->
                                           </v-row>
                                         </div>
                                       </div>
                                      
                                      <!-- Total selisih -->
                                      <!-- <v-divider class="my-3"></v-divider>
                                      <div class="fs-13 font-weight-bold mb-2">
                                        <v-icon left color="#1814F3" size="16">mdi-calculator</v-icon>
                                        Total Selisih (Keseluruhan)
                                      </div>
                                      <v-row>
                                        <v-col cols="12" md="4">
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-13">Total Selisih Pcs:</span>
                                            <div class="d-flex align-center">
                                              <span class="fs-13 font-weight-bold" :class="form_reschedule.selisih_pcs < 0 ? 'red--text' : form_reschedule.selisih_pcs > 0 ? 'green--text' : 'grey--text'">
                                                {{ form_reschedule.selisih_pcs > 0 ? '+' : '' }}{{ form_reschedule.selisih_pcs }}
                                              </span>
                                              <v-icon v-if="form_reschedule.selisih_pcs < 0" size="16" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                              <v-icon v-else-if="form_reschedule.selisih_pcs > 0" size="16" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                              <v-icon v-else size="16" color="grey" class="ml-1">mdi-minus</v-icon>
                                            </div>
                                          </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-13">Total Selisih Dus:</span>
                                            <div class="d-flex align-center">
                                              <span class="fs-13 font-weight-bold" :class="form_reschedule.selisih_dus < 0 ? 'red--text' : form_reschedule.selisih_dus > 0 ? 'green--text' : 'grey--text'">
                                                {{ form_reschedule.selisih_dus > 0 ? '+' : '' }}{{ form_reschedule.selisih_dus }}
                                              </span>
                                              <v-icon v-if="form_reschedule.selisih_dus < 0" size="16" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                              <v-icon v-else-if="form_reschedule.selisih_dus > 0" size="16" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                              <v-icon v-else size="16" color="grey" class="ml-1">mdi-minus</v-icon>
                                            </div>
                                          </div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                          <div class="d-flex justify-space-between mb-1">
                                            <span class="fs-13">Total Selisih Lusin:</span>
                                            <div class="d-flex align-center">
                                              <span class="fs-13 font-weight-bold" :class="form_reschedule.selisih_lusin < 0 ? 'red--text' : form_reschedule.selisih_lusin > 0 ? 'green--text' : 'grey--text'">
                                                {{ form_reschedule.selisih_lusin > 0 ? '+' : '' }}{{ form_reschedule.selisih_lusin }}
                                              </span>
                                              <v-icon v-if="form_reschedule.selisih_lusin < 0" size="16" color="red" class="ml-1">mdi-arrow-down</v-icon>
                                              <v-icon v-else-if="form_reschedule.selisih_lusin > 0" size="16" color="green" class="ml-1">mdi-arrow-up</v-icon>
                                              <v-icon v-else size="16" color="grey" class="ml-1">mdi-minus</v-icon>
                                            </div>
                                          </div>
                                        </v-col>
                                      </v-row> -->
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>

                            <v-row v-if="form_reschedule.bpb_id && form_reschedule.new_bpb_id">
                              <!-- <v-col cols="12">
                                <div v-if="message.error.length > 0" class="mb-3">
                                  <div class="error--text d-flex align-start">
                                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                                    <span class="ml-1">{{ message.error }}</span>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex align-center mr-3">
                                  <v-icon size="16" color="grey" class="mr-1">mdi-information</v-icon>
                                  <span class="fs-12 grey--text">Pastikan data sudah benar sebelum menyimpan. Proses ini tidak dapat dibatalkan dan akan mengubah data surat jalan.</span>
                                </div>
                              </v-col> -->
                              <v-col cols="12" class="d-flex justify-end">
                                <v-btn
                                  color="grey"
                                  elevation="0"
                                  @click="resetForm()"
                                  small
                                  height="36"
                                  class="body-2 text-capitalize border-radius mr-3"
                                  style="font-weight: 600;"
                                  outlined>
                                  <v-icon left>mdi-refresh</v-icon>
                                  Reset
                                </v-btn>
                                <v-btn
                                  color="#1814F3"
                                  elevation="0"
                                  @click="saveReschedule()"
                                  :loading="process.reschedule"
                                  :disabled="process.reschedule || !varianCompatibleData || !selisihNegativeData"
                                  small
                                  height="36"
                                  class="fs-13 white--text text-capitalize border-radius"
                                  style="font-weight: 600;">
                                  <v-icon left size="16">mdi-content-save</v-icon>
                                  Simpan Reschedule
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </ValidationObserver>
                      </v-card-text>  
                    </v-card>
                  </v-col>
                </v-row>
  
                <!-- <v-card v-if="Object.keys(detail).length > 0" flat style="border-radius: 8px;" class="mt-5">
                  <v-card-text>
                    <div class="fs-18 input-label font-weight-bold pt-2 pb-3 black--text d-flex align-center justify-space-between">
                      <div class="d-flex align-center">
                        <v-icon left color="#1814F3" class="mr-2">mdi-cash</v-icon>
                        Data BPB
                      </div>


                    </div>
                    <div style="margin: auto;">
  
                      <div style="overflow-x: auto; min-height: 250px;">
                        <table style="border-radius: 10px; width: 100%; border: thin solid #E6EFF5;" class="table">
                          <tr>
                            <th :style="'left: 0px;'" class="text-left black--text fs-14 font-weight-bold pa-2" style="z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">No BPB</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Tgl Order</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Toko</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Sales</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Wilayah</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Alamat</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">{{ detail.status === 'Set Order' ? 'Akan dikirim' : 'Dikirim' }}</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Diterima</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Dikembalikan</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Rusak</th>
                          </tr>
                          <tr v-for="(item, index) in data_bpb" :key="index">
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="left: 0px; z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5; min-width: 200px; width: 200px;">{{ item.bpb_number }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.orders_number }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.store_name }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.sales_name }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.wilayah }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 300px; min-width: 300px; max-width: 300px; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              {{ item.shipping_province }}, {{ item.shipping_city }}, {{ item.shipping_subdistrict }}, {{ item.shipping_village }}
                            </td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.qty_pcs*1 > 0">
                                {{ item.qty_pcs }} Pcs
                              </div>
                              <div v-if="item.qty_lusin*1 > 0">
                                {{ item.qty_lusin }} Lusin
                              </div>
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.qty_dus | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
  
                              <div v-else>
                                {{ item.qty_dus | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.qty_pcs*1 > 0">
                                {{ item.qty_pcs_diterima }} Pcs
                              </div>
                              <div v-if="item.qty_lusin*1 > 0">
                                {{ item.qty_lusin_diterima }} Lusin
                              </div>
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.qty_dus_diterima | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                              <div v-else>
                                {{ item.qty_dus_diterima | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.qty_pcs*1 > 0">
                                {{ item.qty_pcs_return }} Pcs
                              </div>
                              <div v-if="item.qty_lusin*1 > 0">
                                {{ item.qty_lusin_return }} Lusin
                              </div>
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.qty_dus_return }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.kirim_qty_dus_rusak | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
  
                  </v-card-text>
                </v-card> -->
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                
                <v-btn
                  to="/delivery/reschedule"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Kembali
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    export default {
      data () {
        return {
          approved_by: [],
          approved_reason: '',
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,
  
          dialog: {
            status: false,
            fullscreen: false,
            snackbar: false,
            success: false,
            bukti: false
          },
          bpb_list: [],
          status: '',
  
          detail: {},
  
          rejected_reason: '',
  
          form: {
            id: '',
            bpb_arr: []
          },
          category: [],
          branch: [],
  
          data_bpb: [],
  
          selected: {
            item: [],
            status: [],
            delete: [],
            export: '',
            detail: []
          },
  
          mobilephone: {
            name: '',
            id: ''
          },

          form_reschedule: {
            id: '',
            bpb_id: '',
            new_bpb_id: '',
            qty_pcs: 0,
            qty_dus: 0,
            qty_lusin: 0,
            selisih_pcs: 0,
            selisih_dus: 0,
            selisih_lusin: 0,
          },
          selected_bpb_detail: null,
          selected_new_bpb_detail: null,
          selisihByVarian: {},

          selisihNegativeData: false,
          varianCompatibleData: false,
  
          summary: [],
  
          upload: {
            ttd: null,
            image_url: null
          },

          bpb_list_old: [],

          form_update_bpb: {
            bpb_detail_id: '',
            qty_pcs_diterima: 0,
            qty_dus_diterima: 0,
            qty_pcs_return: 0,
            qty_dus_return: 0,
            kirim_qty_dus_rusak: 0,
            bpb_id: '',
            is_close: ''
          },
          process: {
            form: false,
  
            load: false,
  
            image_url: false,
            update_bpb: false,
            reschedule: false
          },
          
          message: {
            success: '',
            error: '',
            status: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        ValidationObserver,
        ValidationProvider
      },
      watch: {
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      filters: {
        date(value) {
          if (!value) return '-'
          return moment(value).format('DD MMMM YYYY')
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        toNumber(val) {
          const num = parseFloat(val);
          return isNaN(num) ? 0 : num;
        },
        async fetchDetail (no_reload) {
          this.process.load = no_reload === undefined ? true : false
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/surat_jalan/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.form.bpb_arr = []
              this.data_bpb = []
              this.detail = res.results.data
              res.results.data.bpb.map((item, index) => {
                this.form.bpb_arr.push({
                  bpb_id: item.bpb_id,
                  bpb_detail: item.detail
                })
              })

              this.bpb_list_old = res.results.data.bpb
  
              this.form.bpb_arr.map((item, index) => {
                item.bpb_detail.map((items, indexs) => {
                  items.bpb_detail_id = items.bpb_detail_id
                  items.varian_name = items.varian_name
                  items.varian_sku = items.varian_sku
                  items.qty_pcs_diterima = items.qty_pcs_diterima
                  items.qty_dus_diterima = items.qty_dus_diterima
                  items.qty_lusin_diterima = items.qty_lusin_diterima
                  items.qty_pcs_return = items.qty_pcs_return
                  items.qty_dus_return = items.qty_dus_return
                  items.qty_lusin_return = items.qty_lusin_return
                })
              })
  
              res.results.data.bpb.map((item, index) => {
  
                item.detail.map((items, indexs) => {
                  this.data_bpb.push({
                    ... items,
                    ... item,
                    foto_bukti_json: item.foto_bukti_json !== null && item.foto_bukti_json !== '' ? JSON.parse(item.foto_bukti_json) : [],
                    is_checked: false,
                    is_store_closed: item.is_store_closed,
                    qty_dus_return: item.is_store_closed === '1' ? items.qty_dus_return*1 : items.qty_dus_return*1,
                    qty_pcs_return: item.is_store_closed === '1' ? items.qty_pcs_return : items.qty_pcs_return,
                    qty_tetap: item.qty_dus_muat*1
                  })
                })
              })
              this.summarizeByVarian()
            }
            this.process.load = false
            this.fetchBpb()
          })
        },
        async fetchBpb  () {
          let bpb_id = this.detail.bpb.map(item => item.bpb_id)
          let params = {
            is_delivery: '0',
            'id[nin]': bpb_id.join(','),
            limit: 1000,
          }
          await get('admin/bpb/data', { params })
          .then(response => {
            let res = response.data
            if (res.status === 200) {
              this.bpb_list = res.results.data
            }
          })
        },
  
        summarizeByVarian() {
          const summaryObj = {};
          const bpbList = this.detail.bpb;
  
          // bpbList.forEach(bpb => {
            this.data_bpb.forEach(detail => {
              const varianId = detail.varian_id;
              const varianName = detail.varian_name;
  
              if (!summaryObj[varianId]) {
                summaryObj[varianId] = {
                  varian_id: varianId,
                  varian_name: varianName,
                  total_qty_pcs: 0,
                  total_qty_dus: 0,
                  total_qty_lusin: 0,
                  total_qty_pcs_diterima: 0,
                  total_qty_dus_diterima: 0,
                  total_qty_lusin_diterima: 0,
                  total_qty_pcs_return: 0,
                  total_qty_dus_return: 0,
                  total_qty_lusin_return: 0,
                  total_qty_dus_muat: 0,
                  total_qty_dus_rusak: 0,
                  total_qty_in_dus: 0
                };
              }
  
              summaryObj[varianId].total_qty_pcs += Number(detail.qty_pcs);
              summaryObj[varianId].total_qty_dus += Number(detail.qty_dus);
              summaryObj[varianId].total_qty_lusin += Number(detail.qty_lusin);
              summaryObj[varianId].total_qty_pcs_diterima += Number(detail.qty_pcs_diterima);
              summaryObj[varianId].total_qty_dus_diterima += Number(detail.qty_dus_diterima);
              summaryObj[varianId].total_qty_lusin_diterima += Number(detail.qty_lusin_diterima);
              summaryObj[varianId].total_qty_pcs_return += Number(detail.qty_pcs_return);
              summaryObj[varianId].total_qty_dus_return += Number(detail.qty_dus_return);
              summaryObj[varianId].total_qty_lusin_return += Number(detail.qty_lusin_return);
              summaryObj[varianId].total_qty_dus_muat += Number(detail.qty_dus_muat);
              summaryObj[varianId].total_qty_dus_rusak += Number(detail.kirim_qty_dus_rusak);
              summaryObj[varianId].total_qty_in_dus += Number(detail.qty_in_dus);
            });
          // });
  
          // Convert object ke array
          this.summary = Object.values(summaryObj).reverse();
        },
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.rejected_reason = ''
  
          this.process.form = false
  
          this.message.error = ''
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
  
        async saveUpdateBpb (index) {
          this.message.error = ''
          const isValid = true
          if (isValid) {
            
  
          this.process.update_bpb = true
  
          let url = 'admin/bpb/update_detail'
  
          await post(url, {
            data: this.form_update_bpb
          }).then(response => {
            let res = response.data
  
            this.process.update_bpb = false
  
            if (res.status === 200) {
              this.process.update_bpb = false
              this.data_bpb[index].is_checked = true
              this.data_bpb[index].qty_pcs_diterima = this.form_update_bpb.qty_pcs_diterima
              this.data_bpb[index].qty_dus_diterima = this.form_update_bpb.qty_dus_diterima
              this.data_bpb[index].qty_pcs_return = this.form_update_bpb.qty_pcs_return
              this.data_bpb[index].qty_dus_return = this.form_update_bpb.qty_dus_return
              this.data_bpb[index].kirim_qty_dus_rusak = this.form_update_bpb.kirim_qty_dus_rusak
              this.summarizeByVarian()
            } else {
              this.message.error = res.message
            }
          })
            
          } else {
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
  
          
        },
  
                async save () {
          this.message.error = ''
          const isValid = true
          if (isValid) {
            

          this.process.form = true

          let url = 'admin/surat_jalan/confirm'

          await post(url, {
            data: {
              id: this.detail.id
            }
          }).then(response => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.dialog.status = false

              this.dialog.success = true
              
              // this.dialog.snackbar = true
              // this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }

          
        },

        onBpbSelected() {
          if (this.form_reschedule.bpb_id) {
            this.selected_bpb_detail = this.data_bpb.find(item => item.bpb_id === this.form_reschedule.bpb_id)
            this.calculateSelisih()
          } else {
            this.selected_bpb_detail = null
          }
        },

        onNewBpbSelected() {
          if (this.form_reschedule.new_bpb_id) {
            this.selected_new_bpb_detail = this.bpb_list.find(item => item.id === this.form_reschedule.new_bpb_id)
            this.calculateSelisih()
          } else {
            this.selected_new_bpb_detail = null
          }
        },

        calculateSelisih() {
          if (this.selected_bpb_detail && this.selected_new_bpb_detail) {
            // Hitung selisih berdasarkan varian_id
            let selisihByVarian = {}
            
            // Proses BPB lama
            if (this.selected_bpb_detail.detail && this.selected_bpb_detail.detail.length > 0) {
              this.selected_bpb_detail.detail.forEach(detail => {
                const varianId = detail.varian_id
                if (!selisihByVarian[varianId]) {
                  selisihByVarian[varianId] = {
                    varian_name: detail.varian_name,
                    varian_sku: detail.varian_sku,
                    qty_pcs_old: 0,
                    qty_dus_old: 0,
                    qty_lusin_old: 0,
                    qty_pcs_new: 0,
                    qty_dus_new: 0,
                    qty_lusin_new: 0,
                    selisih_pcs: 0,
                    selisih_dus: 0,
                    selisih_lusin: 0,
                    total_in_dus: detail.qty_in_dus,
                    bpb_detail_id_old: detail.bpb_detail_id,
                    bpb_detail_id_new: null
                  }
                }
                selisihByVarian[varianId].qty_pcs_old = this.toNumber(detail.qty_pcs)
                selisihByVarian[varianId].qty_dus_old = this.toNumber(detail.qty_dus)
                selisihByVarian[varianId].qty_lusin_old = this.toNumber(detail.qty_lusin)
              })
            }
            
            // Proses BPB baru
            if (this.selected_new_bpb_detail.bpb_detail && this.selected_new_bpb_detail.bpb_detail.length > 0) {
              this.selected_new_bpb_detail.bpb_detail.forEach((detail, index) => {
                const varianId = detail.bpb_detail_varian_id
                if (!selisihByVarian[varianId]) {
                  selisihByVarian[varianId] = {
                    varian_name: detail.bpb_detail_varian_name,
                    varian_sku: detail.bpb_detail_varian_sku,
                    qty_pcs_old: 0,
                    qty_dus_old: 0,
                    qty_lusin_old: 0,
                    qty_pcs_new: 0,
                    qty_dus_new: 0,
                    qty_lusin_new: 0,
                    selisih_pcs: 0,
                    selisih_dus: 0,
                    selisih_lusin: 0,
                    total_in_dus: this.selected_new_bpb_detail.detail[index].orders_detail_total_in_dus,
                    bpb_detail_id_old: null,
                    bpb_detail_id_new: detail.bpb_detail_id
                  }
                } else {
                  // Update bpb_detail_id_new jika varian sudah ada
                  selisihByVarian[varianId].bpb_detail_id_new = detail.bpb_detail_id
                }
                selisihByVarian[varianId].qty_pcs_new = this.toNumber(detail.bpb_detail_qty_pcs)
                selisihByVarian[varianId].qty_dus_new = this.toNumber(detail.bpb_detail_qty_dus)
                selisihByVarian[varianId].qty_lusin_new = this.toNumber(detail.bpb_detail_qty_lusin)
              })
            }
            
            // Hitung selisih untuk setiap varian
            Object.keys(selisihByVarian).forEach(varianId => {
              const varian = selisihByVarian[varianId]
              varian.selisih_pcs = varian.qty_pcs_old - varian.qty_pcs_new
              varian.selisih_dus = varian.qty_dus_old - varian.qty_dus_new
              varian.selisih_lusin = varian.qty_lusin_old - varian.qty_lusin_new
            })
            
            // Simpan selisih per varian
            this.selisihByVarian = selisihByVarian
            
            // Hitung total selisih
            let totalPcsOld = 0
            let totalDusOld = 0
            let totalLusinOld = 0
            let totalPcsNew = 0
            let totalDusNew = 0
            let totalLusinNew = 0
            
            Object.values(selisihByVarian).forEach(varian => {
              totalPcsOld += varian.qty_pcs_old
              totalDusOld += varian.qty_dus_old
              totalLusinOld += varian.qty_lusin_old
              totalPcsNew += varian.qty_pcs_new
              totalDusNew += varian.qty_dus_new
              totalLusinNew += varian.qty_lusin_new
            })
            
            this.form_reschedule.selisih_pcs = totalPcsNew - totalPcsOld
            this.form_reschedule.selisih_dus = totalDusNew - totalDusOld
            this.form_reschedule.selisih_lusin = totalLusinNew - totalLusinOld
          }
        },

        resetForm() {
          this.form_reschedule.bpb_id = ''
          this.form_reschedule.new_bpb_id = ''
          this.selected_bpb_detail = null
          this.selected_new_bpb_detail = null
          this.form_reschedule.selisih_pcs = 0
          this.form_reschedule.selisih_dus = 0
          this.form_reschedule.selisih_lusin = 0
          this.selisihByVarian = {}
        },

        getTotalVariants() {
          let total = 0
          this.data_bpb.forEach(item => {
            if (item.detail && item.detail.length > 0) {
              total += item.detail.length
            }
          })
          return total
        },
        checkVarianCompatibility() {
          if (!this.selected_bpb_detail || !this.selected_new_bpb_detail) {
            return false
          }

          // Ambil semua varian_id dari BPB lama
          const oldVarianIds = new Set()
          if (this.selected_bpb_detail.detail && this.selected_bpb_detail.detail.length > 0) {
            this.selected_bpb_detail.detail.forEach(detail => {
              oldVarianIds.add(detail.varian_id)
            })
          }

          // Ambil semua varian_id dari BPB baru
          const newVarianIds = new Set()
          if (this.selected_new_bpb_detail.bpb_detail && this.selected_new_bpb_detail.bpb_detail.length > 0) {
            this.selected_new_bpb_detail.bpb_detail.forEach(detail => {
              newVarianIds.add(detail.bpb_detail_varian_id)
            })
          }

          // Cek apakah jumlah varian sama dan semua varian_id sama
          return oldVarianIds.size === newVarianIds.size && 
            [...oldVarianIds].every(id => newVarianIds.has(id))
        },
        getAlertStatus() {
          const varianCompatible = this.checkVarianCompatibility()
          console.log(this.form_reschedule.selisih_dus)
          const selisihNegative = (this.form_reschedule.selisih_dus < 0)

          if (selisihNegative === false) { 
            if (this.form_reschedule.selisih_dus === 0) {
              selisihNegative = true
              return {
                type: 'success',
                message: 'Quantity BPB baru lebih sedikit atau sama dengan BPB lama'
              }
            }
          }

          this.varianCompatibleData = varianCompatible
          this.selisihNegativeData = selisihNegative

          console.log(varianCompatible, selisihNegative)
          
          // Error: varian tidak sama atau varian sama tapi selisih < 0
          if (!varianCompatible || !selisihNegative) {
            return {
              type: 'error',
              message: !varianCompatible ? 'Reschedule tidak bisa dilakukan karena Varian BPB lama dan BPB baru berbeda' : 'Reschedule tidak bisa dilakukan karena Quantity BPB baru lebih banyak dari BPB lama'
            }
          }
          // success: varian sama dan selisih >= 0
          else if (varianCompatible && selisihNegative) {
            return {
              type: 'success',
              message: 'Quantity BPB baru lebih sedikit atau sama dengan BPB lama'
            }
          }
        },

        async saveReschedule() {
          this.message.error = ''
          
          // Validasi BPB tidak boleh sama
          if (this.form_reschedule.bpb_id === this.form_reschedule.new_bpb_id) {
            this.message.error = 'BPB lama dan BPB baru tidak boleh sama'
            return
          }
          
          // Validasi data harus dipilih
          if (!this.selected_bpb_detail || !this.selected_new_bpb_detail) {
            this.message.error = 'Silakan pilih BPB lama dan BPB baru terlebih dahulu'
            return
          }
          
          const isValid = await this.$refs.form_reschedule.validate()
          if (isValid) {
            // Konfirmasi sebelum menyimpan
            // if (confirm('Apakah Anda yakin ingin melakukan reschedule BPB ini?')) {
              this.process.reschedule = true

              let bpb_detail_array = []
              console.log(this.selisihByVarian)
              Object.keys(this.selisihByVarian).forEach(item => {
                const varian = this.selisihByVarian[item]
                bpb_detail_array.push({
                  bpb_detail_id: varian.bpb_detail_id_new,
                  bpb_detail_qty_pcs_selisih: varian.selisih_pcs,
                  bpb_detail_qty_dus_selisih: varian.selisih_dus,
                  bpb_detail_qty_lusin_selisih: varian.selisih_lusin,
                })
              })

              console.log(bpb_detail_array)

              await post(`admin/bpb/reschedule`, {
                data: {
                  bpb_delivery_id: this.$route.params.id,
                  bpb_detail_array: bpb_detail_array,
                  bpb_id_old: this.form_reschedule.bpb_id,
                  bpb_id_new: this.form_reschedule.new_bpb_id
                }
              })
              .then((response) => {
                let res = response.data

                this.process.reschedule = false

                if (res.status === 200) {

                  this.dialog.snackbar = true
                  this.message.success = res.message
                  this.message.error = ''
                  this.resetForm()
                  this.fetchDetail()

                } else {
                  this.message.error = res.message
                }
              })

              // await post(url, {
              //   data: {
              //     surat_jalan_id: this.detail.id,
              //     old_bpb_id: this.form_reschedule.bpb_id,
              //     new_bpb_id: this.form_reschedule.new_bpb_id,
              //     bpb_delivery_id: this.$route.params.id,
              //     selisih_pcs: this.form_reschedule.selisih_pcs,
              //     selisih_dus: this.form_reschedule.selisih_dus,
              //     selisih_lusin: this.form_reschedule.selisih_lusin
              //   }
              // }).then(response => {
              //   let res = response.data

              //   this.process.reschedule = false

              //   if (res.status === 200) {
              //     this.$toast.success('Reschedule BPB berhasil disimpan!')
              //     this.resetForm()
              //     this.fetchDetail()
              //   } else {
              //     this.message.error = res.message
              //   }
              // }).catch(error => {
              //   this.process.reschedule = false
              //   this.message.error = 'Terjadi kesalahan saat menyimpan reschedule BPB'
              // })
            // }
          }
        }
      }
    }
  </script>

<style>
  .custom-placeholder-autocomplete ::placeholder {
    font-size: 12px !important;
  }

  .custom-placeholder-autocomplete .v-input__control .v-input__slot {
   font-size: 13px !important;
  }
</style>